import { Group, Stack, useMantineTheme } from '@mantine/core';
import { capitalize } from 'lodash';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Goal } from '@feathr/blackbox';
import { CardV2, Text } from '@feathr/components';
import { goalTypeLabels } from '@feathr/extender/components/Goal/Goal.predicates';

import { formatGoalValue } from '../../ReportsConversionsGoalManagerPage.utils';

interface IGoalDetailDefinitionProps {
  goal: Goal;
}

function GoalDetailDefinition({ goal }: Readonly<IGoalDetailDefinitionProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const convType = goal.get('conv_type');
  const typeLabel = capitalize(goalTypeLabels[convType] ?? convType ?? '');

  return (
    <CardV2 name={'goal-definition'} width={'full'}>
      <CardV2.Header title={t('Definition')} />
      <CardV2.Content addVerticalGap={true}>
        <Stack gap={theme.spacing['4']}>
          <Group justify={'space-between'}>
            <Text.SmallSemibold>{t('Type')}</Text.SmallSemibold>
            <Text.DefaultRegular>{typeLabel}</Text.DefaultRegular>
          </Group>
          <Group justify={'space-between'}>
            <Text.SmallSemibold>{t('Goal value')}</Text.SmallSemibold>
            <Text.DefaultRegular>{formatGoalValue(goal, t)}</Text.DefaultRegular>
          </Group>
        </Stack>
      </CardV2.Content>
    </CardV2>
  );
}

export default observer(GoalDetailDefinition);
